import { getLoginAccountId, getLoginShopid, getWebId } from '@RootCommon/utils'
import { commonRequest } from '../utils/request'

export const reportEvent = async (url: string, params = {}) => commonRequest.post(url, {
  appInfo: await getAppInfo(),
  ...params,
})

const getAppInfo = async () => ({
  shopId: getLoginShopid(),
  accountId: getLoginAccountId(),
  uuid: getWebId(),
  ver: await window.top.electronAPI?.getVersion(),
})
